import axiosClient from "./axios";
import { GET_ALL_SHOPS } from "../constants/endpoints";

class shopKycService {
  static async fetchAllKycShops(
    currentPage: number,
    itemsPerPage: number,
    isKycPresent: boolean,
    shopName: string,
    category: string,
    pincode: string,
    isActive: boolean,
    created_at: string,
    modified_at: string
  ) {
    const filters = {
      isKycPresent: isKycPresent !== null ? isKycPresent : undefined,
      shopName: shopName !== null ? shopName : undefined,
      category: category !== null ? category : undefined,
      pincode: pincode !== null ? pincode : undefined,
      isActive: isActive !== null ? isActive : undefined,
    };
    const sort = {
      created_at: created_at !== null ? created_at : undefined,
      modified_at: modified_at !== null ? modified_at : undefined,
    };
    const response = await axiosClient.post(GET_ALL_SHOPS, {
      page: currentPage,
      limit: itemsPerPage,
      filters: filters,
      sort: sort,
    });
    return response;
  }
}
export default shopKycService;
